// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import { apiSlice } from '../slices/apiSlice';
import { authApi } from '../slices/loginRegisterSlice';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { setupListeners } from "@reduxjs/toolkit/query";
import { getApi } from '../slices/getSlice';
import { settingSlice } from '../slices/settingSlice';
import dateReducer from "../slices/dateSlice";
import PropertyReducer from "../slices/PropertySlice";

import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist/es/constants';
const persistConfig = {
  key: 'root',
  storage,
}
const persistedReducer = persistReducer(persistConfig, authReducer)
export const store = configureStore({
  reducer: {
    persistedReducer,
    date: dateReducer,
    Property:PropertyReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [getApi.reducerPath]: getApi.reducer,
    [settingSlice.authReducer]: settingSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware, authApi.middleware, getApi.middleware, settingSlice.middleware),
});
setupListeners(store.dispatch)
export const persistor = persistStore(store)

